export default {"src":"/_next/static/media/houses_24.c7839109.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};